import createIcon from '../../createIcon';

/**
 * @component @name MenuOpen
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxOEgxNlYxNkgzVjE4Wk0zIDEzSDEzVjExSDNWMTNaTTMgNlY4SDE2VjZIM1pNMjEgMTUuNTlMMTcuNDIgMTJMMjEgOC40MUwxOS41OSA3TDE0LjU5IDEyTDE5LjU5IDE3TDIxIDE1LjU5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MenuOpen = createIcon('MenuOpen', [
  [
    'path',
    {
      d: 'M3 18H16V16H3V18ZM3 13H13V11H3V13ZM3 6V8H16V6H3ZM21 15.59L17.42 12L21 8.41L19.59 7L14.59 12L19.59 17L21 15.59Z',
      key: 'd5htrl',
    },
  ],
]);

export default MenuOpen;
